function getCookie(name) {
    let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}




(function($) { 
$(document).ready(function() {

let header_h = 152;
let mobile_w = 768;

function is_mobile()
{
  return ($(window).width() < mobile_w) ? true : false;
}

function fill_product(element, product)
{
    element.find('.catalog-product__media, .catalog-product__description').attr('href', '/products/' + product.handle);
  
    if (product.images[0]) {
      element.find('.catalog-product__image').attr('src', product.images[0].src ? product.images[0].src : product.images[0]);
    }
  
    element.find('.catalog-product__title').text(product.title);
    element.find('.catalog-product__price').text(Shopify.formatMoney(product.variants[0].price, "{{amount}} $"));

    for (let i = 0; i < product.tags.length; i++) {
      product.tags[i] = product.tags[i].charAt(0).toUpperCase() + product.tags[i].toLowerCase().slice(1);
    }
console.log('product.meta>>>>>>>>>',product);
    element.find('.catalog-product__tags').append(product.description);
    
    
    if (product.variants[0].grams != undefined) {
      amount = product.variants[0].grams;
    } else if (product.variants[0].weight != undefined) {
      amount = product.variants[0].weight;
    }

    element.find('.catalog-product__amount').text('');
    element.find('input[type="hidden"][name="idtrue"]').val(product.id);
    element.find('input[type="hidden"][name="id"]').val(product.variants[0].id);
}

$(window).on('resize', function(){
 
  if (is_mobile()) {
    $('.catalog__grid_recently-viewed').trigger('refreshCarousel', '[all]');
  } else {
    recently_viewed_products(); 
  }
});

/*** Header, language selector ***/
// function lang_dropdown(show)
// {
//   if (!show) {
//     $('.header__lang-dropdown').slideUp(200);
//     $('.header__lang-icon-dropdown').removeClass('header__lang-icon-dropdown_opened');
//   } else {
//     $('.header__lang-dropdown').slideDown(200);
//     $('.header__lang-icon-dropdown').addClass('header__lang-icon-dropdown_opened');
//   }
// }

// $('.header__lang').click(function(e) {

//   e.stopPropagation();
  
//   if ($('.header__lang-dropdown').is(':visible')) {
//     lang_dropdown(false);
//   } else {
//     lang_dropdown(true);
//     help_dropdown(false);
//     hide_menu_mobile();
//   }
// });

// $('body').click(function(){
//   if ($('.header__lang-dropdown').is(':visible')) {
//     lang_dropdown(false);
//   }
// });

function help_dropdown(show)
{
  if (!show) {
    $('.header__help-dropdown').slideUp(200);
  } else {
    $('.header__help-dropdown').slideDown(200);
  }
}
  
$('.header__help').click(function() {

  if ($('.header__help-dropdown').is(':visible')) {
    help_dropdown(false);
  } else {
    help_dropdown(true);
    lang_dropdown(false);
  }
});  
  
/*** Menu ***/
let top_last = 0;
let menu_mouse_over;
  
$(window).scroll(function(event) {

    if ($(window).width() < 992 || menu_mouse_over) {
      return;
    }
  
    const top = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0);

    if (top > top_last && top > 10) {
      if ($('.header__menu').is(':visible')) {

        $('.header__menu').slideUp(300, function(){
            header_h = 152 - 71;
        });

        menu_dropdown_hide();
      }
    } else if ($('.header__menu').is(':hidden')) {

      $('.header__menu').slideDown(300, function(){
          header_h = 152;
      });
    }

    top_last = top;
});

/** Menu dropdown **/
let menu_shown = '';
  
function menu_dropdown_hide()
{
  $('.site-nav__dropdown_shown')
    .slideUp(300)
    .removeClass('site-nav__dropdown_shown');

  $('.site-nav__item_active').removeClass('site-nav__item_active');
 /* Remove the property entirely: a lingering blur(0) still creates a
   containing block and hijacks every position:fixed descendant. */
document.querySelector('.main').style.filter = '';
  setTimeout(function(){

    $('.site-nav__dropdown_shown').each(function(){

      if ($(this).parent('.site-nav__item').data('handle') != menu_shown) {
        $(this)
          .removeClass('site-nav__dropdown_shown')
          .hide();
        /* Remove the property entirely: a lingering blur(0) still creates a
   containing block and hijacks every position:fixed descendant. */
document.querySelector('.main').style.filter = '';
      }
    });
  }, 500);

  menu_shown = '';
}
  
$('.site-nav__item').mouseover(function(){ 

  menu_mouse_over = true;

  if ($(this).data('handle') != menu_shown) {

    menu_dropdown_hide();
   
    $(this)
      .addClass('site-nav__item_active')
      .find('.site-nav__dropdown')
      .slideDown(350, function(){
        $(this).addClass('site-nav__dropdown_shown');
        $('.site-nav__slider-slideshow').trigger('refreshCarousel', '[all]');
        document.querySelector('.main').style.filter = 'blur(1.5rem)';
      });
      
    menu_shown = $(this).data('handle');
  }
});

$('.site-nav__item').mouseleave(function(){

  menu_mouse_over = false;
  
  menu_dropdown_hide();
});


/*** Mobile Menu ***/
function hide_menu_mobile()
{
  if ($('.header__menu-mobile').css('left') == '0px') {

    $('.header__menu-mobile')
      .animate({left: '-100%'}, function(){
        $('.header__menu-mobile').hide();
        const blackElement = document.querySelectorAll('.blackElement');
        console.log('0');
        console.log('blackElement', blackElement);
          if (blackElement.length > 0) {
            blackElement.forEach((element) => {
              element.remove();
            });
          }
        $('.mobile-menu').css({transform: 'translate(0, 0)'});
      });
  }
  
}


  
$('.header__hamburger-menu').click(function(){
  
  const blackElement = document.createElement('div');
  const htmlB = document.querySelector('html');
  console.log('blackElement', blackElement);
  blackElement.style.background = '#00000070';
  blackElement.style.position = 'fixed';
  blackElement.style.zIndex = '2';
  blackElement.style.top = '79px';
  blackElement.style.height = '100vh';
  blackElement.style.width = '100vw';
  blackElement.classList.add('blackElement');
  htmlB.append(blackElement);
 
  //Show menu, if hidden
  if ($('.header__menu-mobile').css('left') == '-100%') {
    
    $('.header__menu-mobile')
      .show()
      .animate({left: 0});
  }
});

//Hide menu
$('body').click(hide_menu_mobile);

$('.header__menu-mobile').click(function(e){
  e.stopPropagation();
});

//Show level 2, 3
$('.mobile-menu__open-sublevel').click(function(){

  let from, to;
  
  $('.mobile-menu__level_sublevel').hide();
  $('.mobile-menu__spoiler-title_opened').removeClass('mobile-menu__spoiler-title_opened');
  $('.mobile-menu__list_spoiler').hide();

  //Show corresponding sublevel
  $(this)
    .parents('.mobile-menu__item')
    .children('.mobile-menu__level_sublevel')
    .show();

  //Show "-"
  $(this)
    .parents('.mobile-menu__item')
    .find('.mobile-menu__spoiler-title')
    .first()
    .addClass('mobile-menu__spoiler-title_opened');
  
  //Show level first menu list
  $(this)
    .parents('.mobile-menu__item')
    .find('.mobile-menu__list_spoiler')
    .first()
    .show();

  if ($(this).hasClass('mobile-menu__open-sublevel2')) {
    from = -100;
    to = -200;
    $('.mobile-menu').data('level', 2);
    
  } else {
    from = 0;
    to = -100;
    $('.mobile-menu').data('level', 1);
  }
  
  $('.mobile-menu').prop('step_var', from).animate({step_var: to}, {
      step: function(now, fx){
          $(this).css({transform: 'translate(' + now + '%, 0)'});
          //console.log(now)
      },
      duration: 300,
      easing: 'linear'
  });  
});

//Return one level
$('.mobile-menu__level-return').click(function(){

  let to;

  if ($('.mobile-menu').data('level') == 1) {
    to = 0;
    $('.mobile-menu').data('level', 0);
    
  } else if ($('.mobile-menu').data('level') == 2) {
    to = -100;
    $('.mobile-menu').data('level', 1);
  } 

  $('.mobile-menu').animate({step_var: to}, {
      step: function(now, fx){
          $(this).css({transform: 'translate(' + now + '%, 0)'});
      },
      duration: 300,
      easing: 'linear'
  });  
});

//Menu spoiler: show / hide
$('.mobile-menu__spoiler-title').click(function(){

  $('.mobile-menu__spoiler-title_opened')
    .removeClass('mobile-menu__spoiler-title_opened');
  
  const this_spoiler = $(this).parent().find('.mobile-menu__list_spoiler');

  if (this_spoiler.is(':visible')) {
    
    this_spoiler.slideUp();
    
  } else {
    
    $(this)
      .addClass('mobile-menu__spoiler-title_opened');
    
    $('.mobile-menu__list_spoiler:visible')
      .slideUp();

    this_spoiler.slideDown();
  }
});
  
  
/*** Pages ***/
if ($('.section-products-carouse').length) {
  
  //Init
  $('.e-slideshow_products:first-of-type')
    .show()
    .find('.e-slideshow__wrapper')
    .trigger('refreshCarousel', '[all]');
  
  $('.products-carousel-tabs__tab:first-of-type').addClass('products-carousel-tabs__tab_active');

  //Switch
  $('.products-carousel-tabs__tab').click(function(){
    
    const id = $(this).data('id');
    
    $(this).parent().find('.products-carousel-tabs__tab_active').removeClass('products-carousel-tabs__tab_active');
    $(this).addClass('products-carousel-tabs__tab_active');
    
    $(this).parents('.section-products-carouse').find('.e-slideshow_products').hide();
    $(this).parents('.section-products-carouse')
      .find('.e-slideshow_products_' + id)
      .show()    
      .find('.e-slideshow__wrapper')
      .trigger('refreshCarousel', '[all]');
    
  });
}
                  
  
/*** Product ***/
//Header add to cart button
$('.header-product__add-button').click(function(){    
    $('product-form').find('.product__add-button').trigger('click');
});
  
/** Header sticky product **/
function fill_sticky_product()
{
    //Copy data to Sticky block
    const bg_url = $('.product__carousel-thumb').first().css('background-image');
    $('.header-product__image').css({'background-image': bg_url});
    $('.header-product__title').html($('.product__title').html());
    $('.header-product__subtitle').html($('.product__subtitle').html());
    $('.header-product__price').html($('.product__price').html());

    if ($('.product__variation_active').length) {
        $('.header-product__variations').css({display: 'flex'});
        $('.header-product__variation').html($('.product__variation_active').attr('title'));
    }
}

  
function control_sticky_product()
{
  if (is_mobile()) {
    return;
  }
  
  //const add_to_cart = $('.product__top .product__add');
  const viewportOffset = $('.product__add').get(1).getBoundingClientRect();
  const top = viewportOffset.top;

  if (top < 0) {
    $('.header-product').slideDown();
  } else {
    $('.header-product').slideUp();
  }
}


/** Main product **/
function product_detect_current_image()
{
    let current_image_i;

    $('.product__carousel-slide').each(function(i){

        const viewportOffset = $(this).get(0).getBoundingClientRect();
        const top = viewportOffset.top;
        const h = $(this).outerHeight();

        if (top + h - 10 >= header_h) {
            if (current_image_i == undefined) {
                current_image_i = i;
            }
        }
    });

    if (current_image_i == undefined) {
        
        //$('.header-product').slideDown();
      
    // Highlight product position
    } else {

        //$('.header-product').slideUp();
      
        $('.product__carousel-bullet').removeClass('product__carousel-bullet_active');
        $('.product__carousel-bullet').eq(current_image_i).addClass('product__carousel-bullet_active');
    
        $('.product__carousel-thumb').removeClass('product__carousel-thumb_active');
        $('.product__carousel-thumb').eq(current_image_i).addClass('product__carousel-thumb_active');
    }
}

  // EUR symbol position
  
function product_add_event()
{
  $(document).ready(function() {

  const initialPrice = parseFloat($('.product__price').text().replace(/[€$]/g, ''));
  const maxQuantityIncrease = 4; // Максимальное увеличение количества

  function increaseQuantity() {
      
      const productForm = $(this).closest('.product-form');
      const productTagsRaw = productForm.attr('data-tags') || '[]';
      let productTags = [];
      try {
        productTags = JSON.parse(productTagsRaw);
      } catch (e) {
        console.error("Tags are null:", e);
      }
      const hasDiscoveryTag = productTags.map(tag => tag.toLowerCase().trim()).includes('discovery sets');
      const quantityInput = $('.product__quantity-input');
      let quantity = parseInt(quantityInput.val());

      // Оригинальная логика для обычных товаров (ИСПРАВЛЕНА)
      const priceElement = $('.product__price');
      if (quantity + 1 <= maxQuantityIncrease) {
        quantityInput.val(quantity + 1);
        quantity++;
      }
      
      // Используем `initialPrice`, который был определён выше, вне этой функции
      const updatedPrice = initialPrice * quantity;
      priceElement.text('€' + updatedPrice.toFixed(2).replace('.00', ',00'));
    }

  function decreaseQuantity() {
    const quantityInput = $('.product__quantity-input');
    const priceElement = $('.product__price');
    let quantity = parseInt(quantityInput.val());

    if (quantity > 1) {
      quantityInput.val(quantity - 1);
      quantity--;

      const updatedPrice = initialPrice * quantity;
      priceElement.text('€' + updatedPrice.toFixed(2).replace('.00', ',00'));
    }
  }

  $('.product__quantity-button_plus').click(increaseQuantity);
  $('.product__quantity-button_minus').click(decreaseQuantity);
});



  // Scroll image
  $('.product__carousel-bullet, .product__carousel-thumb').click(function(){
  
      const image_i = $(this).index();
      const offset_top = $('.product__carousel-slide').eq(image_i).offset().top;
  
      $('html, body').animate({
          scrollTop: offset_top - header_h
      }, 1000);
  });


   //Product variation dropdown open (close on body click)
  $('.product__variations-dropdown__notHeader').click(function(e){

    if ($('.product__variations-list__notHeader').is(':hidden')) {
      e.stopPropagation();
      
      $(this).addClass('product__variations-dropdown_opened');
      $('.product__variations-list__notHeader').slideDown();
    }
  });

   //Product variation dropdown HEADER open (close on body click)
  $('.product__variations-dropdown-header').click(function(e){

    if ($('.product__variations-list-header').is(':hidden')) {
      e.stopPropagation();
      
      $(this).addClass('product__variations-dropdown_opened');
      $('.product__variations-list-header').slideDown();
    }
  });
    

  // Get variation by ajax (overlay product variant loader)
  $('.product__variation-link, .product__variation-item').click(function(e){
  
    e.preventDefault();
  
    let product_handle = $(this).data('product-handle');
    let product_variant = $(this).data('variant');
  
    let section_id = $('.shopify-section.section').attr('id').replace(/shopify-section-/i, '');

    $('.product').addClass('product_loading');

    $.ajax({
        type: 'GET',
        dataType: 'html',
        url: window.Shopify.routes.root + 'products/' + product_handle + '?variant=' + product_variant + '&section_id=' + section_id,
        success: function(result) {
          if (innerWidth <= 767) {
            window.history.pushState(product_variant, 'Title', window.Shopify.routes.root + 'products/' + product_handle + '?variant=' + product_variant);
  location.reload();
} else {
window.history.pushState(product_variant, 'Title', window.Shopify.routes.root + 'products/' + product_handle + '?variant=' + product_variant);
location.reload();
            //Save elements
//             $('.slideshow-right-image').parent().appendTo('body');
//             $('.slideshow-right-text').parent().appendTo('body');
//             $('.samples-slider__wrapper').appendTo('body');
//             $('.product__recently-viewed').appendTo('body');
  
//             $('main#MainContent').html(result);

            
//             fill_sticky_product();
//             product_add_event();
//             product_detect_current_image();

//             product_mobile_carousel();

//             //Move elements to new html
//             const rsiw_w = $('.right-slideshow-image-wrapper').width();
//             $('.right-slideshow-image').css({width: rsiw_w + 'px'});
//             $('.right-slideshow-image').parent().appendTo('.right-slideshow-image-wrapper');
//             $('.right-slideshow-image .e-slideshow__wrapper').trigger('refreshCarousel', '[all]');
//             $('.right-slideshow-image').css({width: 'auto'});
            
//             /*const rstw_w = $('.right-slideshow-text-wrapper').width();
//             $('.right-slideshow-text').css({width: rstw_w + 'px'});
//             $('.right-slideshow-text').parent().appendTo('.right-slideshow-text-wrapper');
//             $('.right-slideshow-text .e-slideshow__wrapper').trigger('refreshCarousel', '[all]');*/

//             $('.samples-slider').empty();
//             $('.samples-slider__wrapper').appendTo('.samples-slider');

//             $('.product__recently-viewed-section').empty();
//             $('.product__recently-viewed').appendTo('.product__recently-viewed-section');          
//           addTrithFoto();
//           console.log('asdasd');
//           setTimeout(async () => {
//              console.log('asdasd22');
//     var currentURL = window.location.href;
// var parts = currentURL.split('/');
// var trimmedLanguageNow = parts[3].slice(0,2);  
    
//     let url;

//     switch (trimmedLanguageNow) {
//         case 'fr':
//             url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/Sandra_FR_json_1803.json?v=1710831318';
//             break;
//         case 'de':
//             url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/03032024ROMAN_DE_fa6ae898-7799-4c9a-a78e-b6438ce9159e.json?v=1710229770';
//             break;
//         case 'ru':
//             url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/03032024ROMAN_RU_e9c20175-9e89-49b2-9484-e0849ec7d642.json?v=1710229770';
//             break;
//         case 'it':
//             url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/03032024ROMAN_IT_83ceb5de-a899-4d79-ad8c-e499adbb9fe9.json?v=1710229770';
//             break;
//         case 'zh':
//             url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/03032024ROMAN_CN_8036f82f-1f31-4d59-af83-f11a56c81951.json?v=1710229770';
//             break;
//         default:
//             break;
//     }

//     if (url) {
//         const response = await fetch(url);
//         const data = await response.json();
//         TranslationMainPButtons(data);
//        TranslationMainProduct(data);
//                 TranslationFormButtons(data);
    
//                 const productCLFr = document.querySelector('.product__category-link');
//                 console.log('productCLFr', productCLFr);
//                 if (productCLFr.textContent === 'ÉCHARPES' ) {
//                   console.log('productCLFr2', productCLFr);
                
//                 const tabsButtons2 = document.querySelectorAll('.tabs__tab-buttons span');

//                 tabsButtons2.forEach((tab2) => {
//                   if (tab2.textContent.trim() === "CONSEILS D'APPLICATION") {
//                     console.log('productCLFr3', productCLFr);
//                     tab2.textContent = 'CONSEILS';
//                   }
//                 });
//                 }
//                 const jdgmRevWidgTitle = document.querySelector('.jdgm-rev-widg__title');
//       const jdgmBased = document.querySelector('.jdgm-rev-widg__summary-text');
      
//       switch (trimmedLanguageNow) {
//         case 'fr':
//            jdgmRevWidgTitle.textContent = 'AVIS DES CLIENTS';
//           if (jdgmBased.textContent === 'Be the first to write a review') {
//             jdgmBased.textContent = 'Aucun avis pour le moment';
//           }
//           jdgmBased.textContent = jdgmBased.textContent.replace('Based on', 'Basé sur');
//           jdgmBased.textContent = jdgmBased.textContent.replace('reviews', 'avis');
//             break;
//         case 'de':
//           jdgmRevWidgTitle.textContent = 'KUNDENBEWERTUNGEN';
//           if (jdgmBased.textContent === 'Be the first to write a review') {
//             jdgmBased.textContent = 'Sei der erste der eine Bewertung schreibt';
//           }
//           jdgmBased.textContent = jdgmBased.textContent.replace('Based on', 'Basierend auf');
//           jdgmBased.textContent = jdgmBased.textContent.replace('reviews', 'Bewertungen');
//             break;
//         case 'ru':
//      jdgmRevWidgTitle.textContent = 'ОТЗЫВ ПОКУПАТЕЛЯ';
//           if (jdgmBased.textContent === 'Be the first to write a review') {
//             jdgmBased.textContent = 'Пока нет отзывов';
//           }
//           jdgmBased.textContent = jdgmBased.textContent.replace('Based on', 'На основе');
//           jdgmBased.textContent = jdgmBased.textContent.replace('reviews', 'отзывах');
//             break;
//         case 'it':
//         jdgmRevWidgTitle.textContent = 'RECENSIONI';
//           if (jdgmBased.textContent === 'Be the first to write a review') {
//             jdgmBased.textContent = 'Nessuna recensione';
//           }
//           jdgmBased.textContent = jdgmBased.textContent.replace('Based on', 'Basato su');
//           jdgmBased.textContent = jdgmBased.textContent.replace('reviews', 'recensioni');
//             break;
//         case 'zh':
//            jdgmRevWidgTitle.textContent = '顾客评论';
//           if (jdgmBased.textContent === 'Be the first to write a review') {
//             jdgmBased.textContent = '暂时还没有评论';
//           }
//           jdgmBased.textContent = jdgmBased.textContent.replace('Based on', '根据');
//           jdgmBased.textContent = jdgmBased.textContent.replace('reviews', '评论');
//         default:
//             break;
//     }
//                 console.log('teest'); TranslationMainProductReviews(data);   TranslationReviewInMP(data);
//     }
// }, 500);
          
        }
          
        }
      
    });

    
    
  });

  /** Right scroll **/
  $('.samples-slider__arrow_left').click(function(){
      $(this).parent().find('.samples-slider__wrapper')
  });

  //// Tabs
  // Init
  $('.tabs__tab-button').first().addClass('tabs__tab-button_active');
  $('.tabs__tab-content').first().addClass('tabs__tab-content_active');

  //Tabs button
  $('.tabs__tab-button').click(function(){
  
    const tab_n = $(this).index();

    $('.tabs__tab-button').removeClass('tabs__tab-button_active');
    $(this).addClass('tabs__tab-button_active');

    $('.tabs__tab-content_active').removeClass('tabs__tab-content_active');

    $('.tabs__tab-content').eq(tab_n).addClass('tabs__tab-content_active');
  });

  //Tabs button mobile
  $('.tabs__tab-button-mobile').click(function() {

    if (!$(this).hasClass('tabs__tab-button-mobile_active')) {
      $('.tabs__tab-button-mobile_active').removeClass('tabs__tab-button-mobile_active');
      $(this).addClass('tabs__tab-button-mobile_active');
      $('.tabs__tab-content').slideUp();
      $(this).next('.tabs__tab-content').slideDown();
    } else {
      $('.tabs__tab-button-mobile_active').removeClass('tabs__tab-button-mobile_active');
      $('.tabs__tab-content').slideUp();
    }
  });

  $('.tabs__tab-button-see').click(function() {
  var $tabBox = $(this).parent().find('.tabs__tab-box');
  console
   var currentURL = window.location.href;
  var parts = currentURL.split('/');
  var trimmedLanguageNow = parts[3].slice(0,2); 
  
  
  if ($tabBox.hasClass('tabs__tab-box_clipped')) {
    $tabBox.removeClass('tabs__tab-box_clipped');
    if (trimmedLanguageNow === "fr") {          
    $(this).text('Voir moins');
    } else if (trimmedLanguageNow === "RU") {
      $(this).text('Показывай меньше');
    } else if (trimmedLanguageNow === "CN") {
      $(this).text('顯示較少');
    } else if (trimmedLanguageNow === "DE") {
      $(this).text('Zeige weniger');
    } else if (trimmedLanguageNow === "IT") {
      $(this).text('Mostra meno');
    } else if (trimmedLanguageNow === "EN") {
      $(this).text('Show less');
    } else if (trimmedLanguageNow === "US") {
      $(this).text('Show less');
    }
    
    // Перед анимацией временно устанавливаем высоту на auto
    $tabBox.css('max-height', 'none');
    var expandedHeight = $tabBox.height();
    $tabBox.css('max-height', '150px');
    
    // Задержка перед анимацией для обеспечения плавного начала
    setTimeout(function() {
      $tabBox.css('max-height', expandedHeight + 'px');
    }, 10);
  } else {
    $tabBox.addClass('tabs__tab-box_clipped');
    if (trimmedLanguageNow === "fr") {          
    $(this).text('Voir tous les ingrédients');
    } else if (trimmedLanguageNow === "RU") {
      $(this).text('Посмотреть все ингредиенты');
    } else if (trimmedLanguageNow === "CN") {
      $(this).text('查看所有成分');
    } else if (trimmedLanguageNow === "DE") {
      $(this).text('Alle Zutaten ansehen');
    } else if (trimmedLanguageNow === "IT") {
      $(this).text('Vedi tutti gli ingredienti');
    } else if (trimmedLanguageNow === "EN") {
      $(this).text('See all ingredients');
    } else if (trimmedLanguageNow === "US") {
      $(this).text('See all ingredients');
    }
    
    $tabBox.css('max-height', '150px'); // Возвращаем исходную высоту
  }
});


$('.product__trio-molecular-link').click(function(){

   var currentURL = window.location.href;
  var parts = currentURL.split('/');
  var trimmedLanguageNow = parts[3].slice(0,2); 
  
  var $descriptions = $('.product__trio-molecular-description'); // Получаем все элементы с классом .product__trio-molecular-description

  if ($descriptions.hasClass('product__trio-molecular-description__close')) {
    // Если элементы имеют класс .product__trio-molecular-description__close, значит текст скрыт, поэтому нужно его показать
    $descriptions.removeClass('product__trio-molecular-description__close'); // Удаляем класс .product__trio-molecular-description__close
    if (trimmedLanguageNow === "fr") {          
    $(this).text('Voir moins');
    } else if (trimmedLanguageNow === "RU") {
      $(this).text('Показывай меньше');
    } else if (trimmedLanguageNow === "CN") {
      $(this).text('顯示較少');
    } else if (trimmedLanguageNow === "DE") {
      $(this).text('Zeige weniger');
    } else if (trimmedLanguageNow === "IT") {
      $(this).text('Mostra meno');
    } else if (trimmedLanguageNow === "EN") {
      $(this).text('Show less');
    } else if (trimmedLanguageNow === "US") {
      $(this).text('Show less');
    }
  } else {
    // Если элементы не имеют класс .product__trio-molecular-description__close, значит текст показан, поэтому нужно его скрыть
    $descriptions.addClass('product__trio-molecular-description__close'); // Добавляем класс .product__trio-molecular-description__close
    if (trimmedLanguageNow === "fr") {          
    $(this).text('Découvrir plus');
    } else if (trimmedLanguageNow === "RU") {
      $(this).text('УЗНАТЬ БОЛЬШЕ');
    } else if (trimmedLanguageNow === "CN") {
      $(this).text('發現更多');
    } else if (trimmedLanguageNow === "DE") {
      $(this).text('Mehr entdecken');
    } else if (trimmedLanguageNow === "IT") {
      $(this).text('Scopri di più');
    } else if (trimmedLanguageNow === "EN") {
      $(this).text('Discover more');
    } else if (trimmedLanguageNow === "US") {
      $(this).text('Discover more');
    }

  }
});




}

function recently_viewed_products() {
  if ($('.catalog__grid_recently-viewed').html() != '') {
    return;
  }

  let rvp_cookie = getCookie('recently_viewed_products');
  let rvp = [];
  let new_rvp = [];

  if (main_product_handle) {
    if (rvp_cookie) {
      rvp = rvp_cookie.split(';');
    }

    for (let i in rvp) {
      if (rvp[i] != main_product_handle) {
        new_rvp.push(rvp[i]);
      }
    }

    new_rvp.push(main_product_handle);

    if (new_rvp.length > 4) {
      new_rvp.shift();
    }

    let date = new Date(2050, 0, 1); //To 2050-01-01 00:00:00
    document.cookie = 'recently_viewed_products=' + encodeURIComponent(new_rvp.join(';')) + '; path=/; expires=' + date.toUTCString();
  }

  if (new_rvp.length) {
    for (let i in new_rvp) {
      if (i < 3) {
        jQuery.getJSON(window.Shopify.routes.root + 'products/' + new_rvp[i] + '.js', function (product) {
          if (product.price != 0) {
            $('.product__recently-viewed').show();

            let catalog_product = $('#catalog-product-template .catalog-product').clone();
            catalog_product.css({ order: i });
            catalog_product.addClass('cookieRB-' + i);
            $('.catalog__grid_recently-viewed').append(catalog_product);
            
            fill_product(catalog_product, product);
              
            // fill_cookies(catalog_product, product);
          }
        });
      }
    }
  }
}



function product_mobile_carousel() {

  let carouselOptions = {
    auto: false,
    circular: true,
    autoWidth: true,
    responsive: true,
    visible: 1,
    speed: 500,
    timeout: 2000,
    pause: true,
    preventTouchWindowScroll: false,
    btnGo: $('.product__carousel-mobile-wrapper').parent().find('.e-slideshow__bullet'),
  };
if ($('.e-slideshow__bullets').css('display') === 'none') {
    
  } else {
  $('.product__carousel-mobile-wrapper').jCarouselLite(carouselOptions);
}
}


// If product page
if ($('.product').length) {

    fill_sticky_product();  
    product_add_event();
    product_detect_current_image();
    recently_viewed_products();

    product_mobile_carousel();
  
    $(window).scroll(product_detect_current_image);
    $(window).scroll(control_sticky_product);

    //Close product variations dropdown
    $('body').click(function() {
      $('.product__variations-dropdown').removeClass('product__variations-dropdown_opened');
      $('.product__variations-list').slideUp();
    });

    //Move sliders
// const rsiw_w = $('.right-slideshow-image-wrapper').width();
// $('.right-slideshow-image').css({width: rsiw_w + 'px'});
// $('.right-slideshow-image').parent().appendTo('.right-slideshow-image-wrapper');
    $('.right-slideshow-image .e-slideshow__wrapper').trigger('refreshCarousel', '[all]');
    $('.right-slideshow-image').css({width: 'auto'});

  
}


/*** Product grid ***/
let products_cache = {};
let collections_cache = [];

function show_catalog_product_variation(product, variation_button) {
  
  //Undefined error
  if (!product || !product.variants || !variation_button) {
    return;
  }

  const element = variation_button.parents('.catalog-product');
  const product_variant = variation_button.data('variant');
  
  for (let i in product.variants) {
    if (product.variants[i].id == product_variant) {

      element.find('.catalog-product__image').attr('srcset', ''); 
      
      if (product.variants[i].featured_image && product.variants[i].featured_image.src) {
        element.find('.catalog-product__image').attr('src', product.variants[i].featured_image.src);
      }

      element.find('.catalog-product__variation-title').text(product.variants[i].title);

      element.find('.catalog-product__price').text(Shopify.formatMoney(product.variants[i].price, "{{amount}} $"));
  
      if (product.variants[i].grams != undefined) {
        amount = product.variants[i].grams;
      } else if (product.variants[i].weight != undefined) {
        amount = product.variants[i].weight;
      }

      element.find('.catalog-product__amount').text(amount + ' g');

      element.find('input[type="hidden"][name="id"]').val(product.variants[i].id);

      element.find('.catalog-product__variation').removeClass('catalog-product__variation_active');
      variation_button.addClass('catalog-product__variation_active');
      
      break;
    }
  }
}
  
$('.catalog-product__variation').click(function(e){
  
  e.preventDefault();

  let product = {};
  let variation_button = $(this);
  let product_handle = $(this).data('product-handle');

  if (!products_cache[product_handle]) {
    
    const element = $(this).parents('.catalog-product');
      
    element.addClass('catalog-product_loading');

    $.ajax({
        type: 'get',
        dataType: 'json',
        url: window.Shopify.routes.root + 'products/' + product_handle + '.js',
        success: function(product) {

          show_catalog_product_variation(product, variation_button);

          element.removeClass('catalog-product_loading');

          //To cache
          products_cache[product_handle] = product;
        },
        error: function() {
          element.removeClass('catalog-product_loading');
        }
    });
    
  } else {

    //From cache
    product = products_cache[product_handle];
    
    show_catalog_product_variation(product, variation_button);
  }

  
});

function get_pagination_link(page)
{
  let link;

  //Foreach pagination link
  $('.pagination__item.link').each(function(){

    const url_params = new URLSearchParams($(this).attr('href').replace(/^.*?\?/, ''));
    const url_page = url_params.get('page');

    if (url_page == page) {
      link = $(this).attr('href');
      return;
    }
  });

  return link;
}
  
let catalog_current_page = 1;
  
//Load more button
$('body').click(function(e){

  const click_target = $(e.target);

  if (click_target.hasClass('catalog__load-more_button') && $('.pagination__item.link').length) {

    //Get a link to the next page
    const link = get_pagination_link(catalog_current_page + 1);

    if (link){

      const url_params = new URLSearchParams(link.replace(/^.*?\?/, ''));
      
      const section_id = $('.shopify-section.section').attr('id').replace(/shopify-section-/i, '');
      url_params.set('section_id', section_id);
      data = url_params.toString();
      
      $('.catalog__load-more_button').hide();
      $('.catalog__load-more_loading').show();
      
      $.ajax({
          type: 'GET',
          dataType: 'html',
          url: window.location.origin + window.location.pathname,
          data: data,
          success: function(result) {

            const dom_nodes = $($.parseHTML(result));

            dom_nodes.find('.catalog-product').each(function(){
              $(this).appendTo('.catalog__grid');
            });

            //Insert new pagination links
            $('.catalog__pagination').html(dom_nodes.find('.catalog__pagination'));

            catalog_current_page++;

            $('.catalog__load-more_loading').hide();

            if (get_pagination_link(catalog_current_page + 1)) {
              $('.catalog__load-more_button').show();
            }
            
          }
      });

       setTimeout(async () => {
    var currentURL = window.location.href;
var parts = currentURL.split('/');
var trimmedLanguageNow = parts[3].slice(0,2);  
    
    let url;

    switch (trimmedLanguageNow) {
        case 'fr':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/FR_Sandra_reviewed_9_04.json?v=1712638887';
            break;
        case 'de':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/DE_Sandra_reviewed_9_04.json?v=1712638888';
            break;
        case 'ru':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/RU_Alex_040424_full_c3955efc-1d94-4df1-9d8c-ae8c2780d49b.json?v=1712322526';
            break;
        case 'it':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/IT_Sandra_reviewed_9_04.json?v=1712638887';
            break;
        case 'zh':
            url = 'https://cdn.shopify.com/s/files/1/0665/2798/5877/files/CN_Alex_040424_full_b1bdcc27-55a2-4300-9797-724167ed99d7.json?v=1712322527';
            break;
        default:
            break;
    }

    if (url) {
        const response = await fetch(url);
        const data = await response.json();
        TranslationFormButtons(data);
        TranslationHeaderMenu(data);
    }
}, 500);
      
    }
  }

});
  

/** Filters **/
let filter_timeout;

function update_catalog_grid()
{
    $('.catalog__grid').addClass('catalog__grid_loading');
    $('.facets__display').hide();

    const section_id = 'section_id=' + $('.shopify-section.section').attr('id').replace(/shopify-section-/i, '') + '&';
    let data = $('.facets__form').serialize();

    window.history.pushState(data, 'Title', window.location.origin + window.location.pathname + '?' + data);
  
    data = section_id + data;

    $.ajax({
        type: 'GET',
        dataType: 'html',
        url: window.location.origin + window.location.pathname,
        data: data,
        success: function(result) {

          $('.catalog__grid').removeClass('catalog__grid_loading');
  
          const dom_nodes = $($.parseHTML(result));
          $('.shopify-section.section').html(dom_nodes);
        }
    });
}
  
$('body').click(function(e){

  const click_target = $(e.target);

  if (click_target.prop('tagName') == 'INPUT' && click_target.attr('name') && (click_target.attr('name').match(/filter\.p/) || click_target.attr('name') == 'sort_by')) {

    $('.facets__list.no-js').remove();

    clearTimeout(filter_timeout);

    filter_timeout = setTimeout(update_catalog_grid, 500);
    
  } else if (click_target.prop('tagName') == 'SPAN' && click_target.hasClass('facet__delete-span')) {

    click_target
      .parents('.facets-wrap')
      .removeClass('facets__disclosure_selected')
      .find('input')
      .prop('checked', false);

    update_catalog_grid();
  }
});



/*** END SELECT VARIANT */


let initialPrice;
let quantityInput;
let priceElement;
  
//Add events

 // Add to cart button for variants (overlay window)
  
  

// Plus button с защитой от дублирования

// Minus button с защитой от дублирования

  
//Close product variations dropdown


/*** Footer ***/
$('.footer__lang-switcher').click(function() {

  if ($('.footer__lang-dropdown').is(':visible')) {
    $('.footer__lang-dropdown').hide(200);
    $('.footer__lang-icon-dropdown').removeClass('footer__lang-icon-dropdown_opened');
  } else {
    $('.footer__lang-dropdown').show(200);
    $('.footer__lang-icon-dropdown').addClass('footer__lang-icon-dropdown_opened');
  }
});  


$('.footer__menu-title').click(function() {
  if (is_mobile()) {
    
    if ($(this).hasClass('footer__menu-title_opened')) {

      $('.footer__menu-title_opened').removeClass('footer__menu-title_opened');
      $('.footer__menu').slideUp();
      
    } else {

      $('.footer__menu-title_opened').removeClass('footer__menu-title_opened');
      $('.footer__menu').slideUp();
      
      $(this).parent().find('.footer__menu').slideDown();
      $(this).addClass('footer__menu-title_opened');
    }
  }
});  



//Prevent popup
let ssw_product_link_interval = setInterval(function(){
  if ($('.ssw-fave-list-container .ssw-product-link').length) {
    clearTimeout(ssw_product_link_interval);
    $('.ssw-fave-list-container .ssw-product-link').click(function(e){
      e.stopPropagation();
    });
  }
}, 200);






  

});
})(jQuery);


